export default `<span class="no">Rails</span><span class="p">.</span><span class="nf">application</span><span class="p">.</span><span class="nf">routes</span><span class="p">.</span><span class="nf">draw</span> <span class="k">do</span>
  <span class="nf">command</span> <span class="no">CreateCapybara</span>
  <span class="nf">command</span> <span class="no">IncrementAge</span>
  <span class="nf">command</span> <span class="no">FindCapybara</span>
<span class="k">end</span>`
